import axios from "axios";

export async function sendMotivo(dealId, motivo) {
  if (!dealId) throw new Error("dealId inválido");
  if (!motivo) throw new Error("motivo não pode ser vazio");

  const apiConfig = {
    headers: {
      apikey: "0bd11cb2-42b6-4e97-b132-f2b6c8c3f312",
      "Content-Type": "application/json",
      "X-Moskit-Origin": "WEB",
    }
  };

  try {
    // 1. Buscar o negócio atual
    const { data: deal } = await axios.get(
      `https://api.moskitcrm.com/v2/deals/${dealId}`,
      apiConfig
    );
 console.log("texto do motivo:", motivo);
    // 2. Atualizar o campo customizado (substitui se já existir)
    const updatedCustomFields = [
      ...(deal.entityCustomFields || []).filter(
        (field) => field.id !== "CF_Rg7MnEiLCANo8qvd"
      ),
      { id: "CF_Rg7MnEiLCANo8qvd", textValue: motivo }
    ];

    // 3. Montar o payload completo conforme documentação
    const payload = {
      id: deal.id,
      name: deal.name,
      status: deal.status,
      price: deal.price,
      stage: deal.stage,
      responsible: deal.responsible,
      createdBy: deal.createdBy,
      dateCreated: deal.dateCreated,
      origin: deal.origin,
      source: deal.source,
      contact: deal.contact,
      contacts: deal.contacts,
      entityCustomFields: updatedCustomFields
      // Adicione outros campos obrigatórios conforme necessário
    };

    // 4. Enviar o PUT com o objeto completo
    const response = await axios.put(
      `https://api.moskitcrm.com/v2/deals/${dealId}`,
      payload,
      apiConfig
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar motivo:", error?.response?.data || error);
    throw error;
  }
}